import React from 'react';

const MockProgress = () => {
  const mockTests = [
    { id: 1, name: 'Full Length Test 1', score: 85, date: '2024-01-15', timeSpent: '88 min' },
    { id: 2, name: 'Quick Test 1', score: 78, date: '2024-01-10', timeSpent: '28 min' },
    { id: 3, name: 'Full Length Test 2', score: 92, date: '2024-01-05', timeSpent: '85 min' },
  ];

  return (
    <div style={styles.container}>
      <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet" />
      
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.titleSection}>
            <h1 style={styles.title}>Mock Progress</h1>
            <p style={styles.subtitle}>Track your mock test performance and improvements</p>
          </div>
        </div>
      </div>

      <div style={styles.divider}></div>

      <div style={styles.section}>
        <div style={styles.content}>
          <div style={styles.summaryCard}>
            <h2 style={styles.summaryTitle}>Overall Performance</h2>
            <div style={styles.summaryStats}>
              <div style={styles.summaryStat}>
                <div style={styles.statValue}>85%</div>
                <div style={styles.statLabel}>Average Score</div>
              </div>
              <div style={styles.summaryStat}>
                <div style={styles.statValue}>3</div>
                <div style={styles.statLabel}>Tests Taken</div>
              </div>
              <div style={styles.summaryStat}>
                <div style={styles.statValue}>+12%</div>
                <div style={styles.statLabel}>Improvement</div>
              </div>
            </div>
          </div>

          <div style={styles.testsList}>
            <h3 style={styles.testsTitle}>Recent Mock Tests</h3>
            {mockTests.map(test => (
              <div key={test.id} style={styles.testCard}>
                <div style={styles.testInfo}>
                  <div style={styles.testName}>{test.name}</div>
                  <div style={styles.testDate}>{test.date}</div>
                </div>
                <div style={styles.testStats}>
                  <div style={styles.testScore}>
                    <span style={styles.scoreValue}>{test.score}%</span>
                    <span style={styles.scoreLabel}>Score</span>
                  </div>
                  <div style={styles.testTime}>
                    <span style={styles.timeValue}>{test.timeSpent}</span>
                    <span style={styles.timeLabel}>Time</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    padding: '20px',
    fontFamily: '"Open Sans", sans-serif',
  },
  header: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: '30px',
    marginBottom: '25px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
    border: '1px solid #e0e0e0'
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  titleSection: {
    flex: 1
  },
  title: {
    fontSize: '32px',
    fontWeight: '600',
    margin: '0 0 8px 0',
    color: '#2c5aa0',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0px',
    lineHeight: '1.2'
  },
  subtitle: {
    fontSize: '16px',
    margin: '0',
    color: '#666666',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0.25px',
    lineHeight: '1.5'
  },
  divider: {
    height: '1px',
    backgroundColor: '#e0e0e0',
    margin: '20px 0',
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  section: {
    maxWidth: '1200px',
    margin: '0 auto 30px auto'
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  summaryCard: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: '30px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: '1px solid #e0e0e0',
    marginBottom: '30px',
  },
  summaryTitle: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#2c5aa0',
    marginBottom: '20px',
    fontFamily: '"Open Sans", sans-serif',
  },
  summaryStats: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: '20px',
  },
  summaryStat: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#333333',
    marginBottom: '8px',
    fontFamily: '"Open Sans", sans-serif',
  },
  statLabel: {
    fontSize: '14px',
    color: '#666666',
    fontWeight: '500',
    fontFamily: '"Open Sans", sans-serif',
  },
  testsList: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: '30px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: '1px solid #e0e0e0',
  },
  testsTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#2c5aa0',
    marginBottom: '20px',
    fontFamily: '"Open Sans", sans-serif',
  },
  testCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    marginBottom: '12px',
  },
  testInfo: {
    flex: 1,
  },
  testName: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333333',
    marginBottom: '4px',
    fontFamily: '"Open Sans", sans-serif',
  },
  testDate: {
    fontSize: '14px',
    color: '#666666',
    fontFamily: '"Open Sans", sans-serif',
  },
  testStats: {
    display: 'flex',
    gap: '20px',
  },
  testScore: {
    textAlign: 'center',
  },
  testTime: {
    textAlign: 'center',
  },
  scoreValue: {
    display: 'block',
    fontSize: '18px',
    fontWeight: '600',
    color: '#28a745',
    fontFamily: '"Open Sans", sans-serif',
  },
  timeValue: {
    display: 'block',
    fontSize: '18px',
    fontWeight: '600',
    color: '#666666',
    fontFamily: '"Open Sans", sans-serif',
  },
  scoreLabel: {
    fontSize: '12px',
    color: '#666666',
    fontFamily: '"Open Sans", sans-serif',
  },
  timeLabel: {
    fontSize: '12px',
    color: '#666666',
    fontFamily: '"Open Sans", sans-serif',
  },
};

export default MockProgress;